import { EmptyState } from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'
import Rota from '@lmc/ui-kit/src/dataDisplay/EmptyState/icons/Rota'
import styled from 'styled-components'
import { Text } from '@lmc/ui-kit/src/general'
import { Spinner } from 'components/generic'

type PublishedRotaOverlayProps = {
  'data-testid'?: string
  isLoading: boolean
}

const PublishedRotaOverlay = ({ isLoading }: PublishedRotaOverlayProps) => {
  const { t } = useTranslation()

  if (isLoading) {
    return (
      <TableOverlay>
        <Spinner />
      </TableOverlay>
    )
  }

  return (
    <TableOverlay>
      <EmptyState
        title={t('NO_EVENTS_MATCHING_FILTERS')}
        description={
          <EmptyStateDescription level={1}>
            {t('NO_EVENTS_MATCHING_FILTERS_DESCRIPTION')}
          </EmptyStateDescription>
        }
        icon={<Rota />}
      />
    </TableOverlay>
  )
}

const EmptyStateDescription = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
  text-align: center;
`

const TableOverlay = styled.div`
  position: absolute;
  top: 66px;
  left: 1px;
  width: calc(100% - 2px);
  height: calc(100% - 67px);
  display: flex;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  z-index: 10;
`

export default PublishedRotaOverlay
